import { GroupsRoute } from '@/system-modules/groups/v1/api/GroupsRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'

export class RemoveGroupRoute extends GroupsRoute<null, null> {
  constructor(private readonly groupUuid: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.DELETE
  }

  url(): string {
    return '/api/system/v1/groups/' + this.groupUuid
  }

  offline(): Promise<ApiResponse<null>> {
    return Promise.resolve(new ApiResponse({ success: true, data: null }))
  }
}
